import { render, staticRenderFns } from "./UploadHipaaModal.vue?vue&type=template&id=2c7a5974&scoped=true"
import script from "./UploadHipaaModal.vue?vue&type=script&lang=js"
export * from "./UploadHipaaModal.vue?vue&type=script&lang=js"
import style0 from "./UploadHipaaModal.vue?vue&type=style&index=0&id=2c7a5974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a5974",
  null
  
)

export default component.exports